import validate from "/home/mariotrombino/git/progetti/NewMed/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/mariotrombino/git/progetti/NewMed/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/mariotrombino/git/progetti/NewMed/app/middleware/auth.js")
}